import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  signup: (data) => api.post('/auth/signup', data),
  signin: (data) => api.post('/auth/signin', data),
  getMe: () => api.get('/auth/me')
};

// Visit APIs
export const visitAPI = {
  getAll: (params) => api.get('/visits', { params }),
  create: (data) => api.post('/visits', data),
  update: (id, data) => api.put(`/visits/${id}`, data),
  delete: (id) => api.delete(`/visits/${id}`)
};

// Sale APIs
export const saleAPI = {
  getAll: (params) => api.get('/sales', { params }),
  create: (data) => api.post('/sales', data),
  update: (id, data) => api.put(`/sales/${id}`, data),
  delete: (id) => api.delete(`/sales/${id}`)
};

// Work Plan APIs
export const workPlanAPI = {
  getAll: (params) => api.get('/workplans', { params }),
  create: (data) => api.post('/workplans', data),
  update: (id, data) => api.put(`/workplans/${id}`, data),
  delete: (id) => api.delete(`/workplans/${id}`)
};

// Admin APIs
export const adminAPI = {
  // Users
  getUsers: () => api.get('/admin/users'),
  getUser: (id) => api.get(`/admin/users/${id}`),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  
  // Products
  getProducts: () => api.get('/admin/products'),
  createProduct: (data) => api.post('/admin/products', data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),
  
  // Vendors
  getVendors: () => api.get('/admin/vendors'),
  createVendor: (data) => api.post('/admin/vendors', data),
  updateVendor: (id, data) => api.put(`/admin/vendors/${id}`, data),
  deleteVendor: (id) => api.delete(`/admin/vendors/${id}`),
  
  // Metadata
  getRegions: () => api.get('/admin/regions'),
  getVisitTypes: () => api.get('/admin/visit-types')
};

// Report APIs
export const reportAPI = {
  getDashboard: () => api.get('/reports/dashboard'),
  getVisitsReport: (params) => api.get('/reports/visits', { params }),
  getSalesReport: (params) => api.get('/reports/sales', { params })
};

export default api;